(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-studio-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-oh-chat]') : null;
    if (!link) return;
    const chat = document.querySelector('shopify-chat');
    if (!chat || !customElements.get('shopify-chat')) return;
    event.preventDefault();
    chat.setAttribute('open', '');
    if (chat.getAttribute('mode') === 'managed') {
      document.querySelector('#chat-drawer')?.open?.();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
